import React from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import './index.scss';

const ClickableText = (props) => (
  <AccessibilityWrapper>
    <div tabIndex={0} role="button" className="clickable-text" {...props} />
  </AccessibilityWrapper>
);

export default ClickableText;
